import useInput from "./useInput";

export default useInput;
